import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ChartDataSets, ChartLegendItem, ChartOptions, ChartType, Chart } from 'chart.js';
import * as $ from 'jquery';
import { NumberFormatPipe } from '../../modules/pipe/number-format.pipe';
import { PublicReportService } from '../../modules/services/public-report.service';
import { ConfigurableFocusTrap } from '@angular/cdk/a11y';
import * as _ from 'lodash';
import * as _moment from 'moment';
const moment = _moment;
@Component({
  selector: 'app-registration-dashboard',
  templateUrl: './registration-dashboard.component.html',
  styleUrls: ['./registration-dashboard.component.scss']
})
export class RegistrationDashboardComponent implements OnInit {
  todaysdate;
  regDashboardReport = [];
  registrationTrendChartData;
  registrationTrendChart;
  registrationChartData;
  appointmentScheduledChartData;
  registrationByAgeChart;
  registrationByAgeChartData;
  registrationsPieChart;
  appointmentScheduledChart;
  regVsAppointmentChart;
  regDailyData;
  appointmentDailyData;
  totalRegistrations;
  topBlockReport;
  state_id = '';
  district_id = '';
  breadCrumbArr = [];
  constructor(
    private publicReportService: PublicReportService,
    public deviceService: DeviceDetectorService,
    public datepipe: DatePipe,
    public numberFormatPipe: NumberFormatPipe
  ) { }

  ngOnInit(): void {
    console.log('Registration component');
    this.todaysdate = new Date();
    this.todaysdate = this.datepipe.transform(this.todaysdate, 'yyyy-MM-dd');
  
    this.publicReportService.filterParams.date = this.datepipe.transform(this.todaysdate, 'yyyy-MM-dd');
  }

  getRegistrationDashboard(datefilter) {
    this.publicReportService.tabname.next("Registration");
    this.publicReportService.isnational.next(true);
    console.log('Registration Dashboard');
    this.publicReportService.getRegistrationDashboardData(this.todaysdate).subscribe(res => {
      this.regDashboardReport = res;
      console.log("resDashboard response", this.regDashboardReport);
      this.registrationTrendChartData = res.timeWiseReport;
      this.registrationChartData = res.topRegData;
      this.totalRegistrations = res.topRegData?.total;
      this.appointmentScheduledChartData = res.appScheduled;
      this.registrationByAgeChartData = res.regByAge;
      this.regDailyData = res.totalRegLast5Day;
      this.appointmentDailyData = res.totalAppLast5Day;
      this.loadRegistrationTrendChart();
      this.loadregistrationsChart();
      this.loadAppointmentScheduledChart();
      this.loadRegistrationsByAgeChart();
      this.loadRegVsAppointmentChart();

    },
      err => {
        console.log("error", err)
        this.regDashboardReport = [];
      });
  }

  //Registration Trends Chart
  loadRegistrationTrendChart() {
    if (this.registrationTrendChart) {
      this.registrationTrendChart.destroy();
    }

    const labels = _.map(this.registrationTrendChartData, 'label');
    const data = _.map(this.registrationTrendChartData, 'count');
    const format = this.numberFormatPipe;
    var configuration = {
      type: 'line',
      data: {
        labels: labels,
        datasets: [{
          type: 'line',
          label: 'Registations',
          // backgroundColor: 'rgb(255, 152 , 0, 0.5)',
          backgroundColor: 'rgb(90, 141, 238, 0.1)',
          borderColor: 'rgb(90 141 238)',
          borderWidth: 2,
          pointBackgroundColor: "rgb(79 95 125)",
          pointBorderWidth: 1,
          pointRadius: 3,
          data: data,
        }]
      },
      options: {
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            usePointStyle: false,
            boxWidth: 20,
            padding: 15,
            fontSize: 9,
          }
        },
        tooltips: {
          mode: 'index',
          intersect: false,
          callbacks: {
            label: function (tooltipItem, data) {
              var label = data.datasets[tooltipItem.datasetIndex].label || '';

              if (label) {
                label += ': ';
              }

              const dataNum = Math.round(tooltipItem.yLabel * 100) / 100;
              label += format.transform(dataNum);
              return label;
            }
          }
        },
        responsive: true,
        scales: {
          xAxes: [{
            beginAtZero: false,
            ticks: {
              autoSkip: false,
              fontSize: 11,
            },
            // stacked: true,
            gridLines: {
              display: false,
              drawBorder: false,
            },
          }],
          yAxes: [{
            // stacked: true,
            barPercentage: 0.3,
            gridLines: {
              color: 'rgb(247, 250, 252)',
              borderDash: [5, 2],
              zeroLineColor: 'rgb(247, 250, 252)',
            },
            ticks: {
              fontSize: 9,
              beginAtZero: true,
              callback: function (label, index, labels) {
                return label / 1000 + 'k';
              }
            }
          }]
        }
      }
    };
    const registrationTrendCtx = $('#registationTrends');
    this.registrationTrendChart = new Chart(registrationTrendCtx, configuration);
    this.registrationTrendChart.update();
  }
  //Registrations chart
  loadregistrationsChart() {
    const format = this.numberFormatPipe;
    var configuration = {
      type: 'pie',
      data: {
        datasets: [{
          data: [
            this.registrationChartData?.male,
            this.registrationChartData?.female,
            this.registrationChartData?.others
          ],
          backgroundColor: ['rgb(90, 141, 238)', 'rgb(245, 67, 148)', 'rgb(255 152 0)'],
          borderWidth: 1,
        }],
        labels: ['Male', 'Female', 'Other']
      },
      options: {
        cutoutPercentage: 70,
        rotation: 1 * Math.PI,
        circumference: 1 * Math.PI,
        responsive: true,
        animation: {
          animateScale: true,
          animateRotate: true
        },
        tooltips: {
          mode: 'index',
          intersect: false,
          callbacks: {
            label: function (tooltipItem, data) {
              var label = data.labels[tooltipItem.index] || '';

              if (label) {
                label += ': ';
              }
              const value = data.datasets[0].data[tooltipItem.index] || 0
              const dataNum = Math.round(value * 100) / 100;
              label += format.transform(dataNum);
              return label;
            }
          }
        },
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            usePointStyle: true,
            boxWidth: 7,
            padding: 15,
            fontSize: 10,
          }
        }
      }
    };

    if (this.registrationsPieChart) {
      this.registrationsPieChart.destroy();
    }

    const registrationsCtx = $('#total-registrations');
    this.registrationsPieChart = new Chart(registrationsCtx, configuration);
  }
  //last 5 days Appointment scheduled chart
  loadAppointmentScheduledChart() {
    const format = this.numberFormatPipe;
    if (this.appointmentScheduledChart) {
      this.appointmentScheduledChart.destroy();
    }
    var labels=[];
    for(let i=0;i<=5;i++){
      labels.push(moment(this.todaysdate).add(i, 'days').format('DD MMM'));
    }
//    const labels = ['12 Mar', '11 Mar', '10 Mar', '9 Mar', '8 Mar', '7 Mar'];
    const data = Object.values(this.appointmentScheduledChartData[0]);

    var configuration = {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [{
          type: 'bar',
          label: 'Appointments',
          backgroundColor: "rgb(85 86 253)",
          borderColor: "rgb(85 86 253)",
          data: data,
        }]
      },
      options: {
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            usePointStyle: false,
            fontSize: 10,
            boxWidth: 10,
            padding: 15,
          }
        },
        tooltips: {
          mode: 'index',
          intersect: false,
          callbacks: {
            label: function (tooltipItem, data) {
              var label = data.datasets[tooltipItem.datasetIndex].label || '';

              if (label) {
                label += ': ';
              }
              const dataNum = Math.round(tooltipItem.yLabel * 100) / 100;
              label += format.transform(dataNum);
              return label;
            }
          }
        },
        scales: {
          xAxes: [{
            barPercentage: 0.25,
            beginAtZero: true,
            ticks: {
              autoSkip: false,
              fontSize: 10,
            },
            stacked: true,
            gridLines: {
              display: false,
              drawBorder: false,
            },
          }],
          yAxes: [{
            stacked: true,
            barPercentage: 0.35,
            gridLines: {
              color: 'rgb(247, 250, 252)',
              borderDash: [5, 0],
              zeroLineColor: 'rgb(247, 250, 252)',
            },
            ticks: {
              fontSize: 9,
              beginAtZero: true,
              callback: function (label, index, labels) {
                return label / 1000 + 'k';
              }
            }
          }]
        },
      }
    };

    var ctx = $('#lastFiveAppointmentScheduled');
    this.appointmentScheduledChart = new Chart(ctx, configuration);
  }

  //Registration by age Chart

  loadRegistrationsByAgeChart() {
    const format = this.numberFormatPipe;
    if (this.registrationByAgeChart) {
      this.registrationByAgeChart.destroy();
    }
    const labels_data = Object.keys(this.registrationByAgeChartData);
    const labels = labels_data.map(obj => obj.replace('reg_', '').replace('_','-').replace('to_',''));
    const data = Object.values(this.registrationByAgeChartData);

    var configuration = {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [{
          type: 'bar',
          label: 'Registrations By Age',
          backgroundColor: "rgb(245, 67, 148)",
          borderColor: "rgb(245, 67, 148)",
          data: data,
        }]
      },
      options: {
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            usePointStyle: false,
            fontSize: 10,
            boxWidth: 10,
            padding: 15,
          }
        },
        tooltips: {
          mode: 'index',
          intersect: false,
          callbacks: {
            label: function (tooltipItem, data) {
              var label = data.datasets[tooltipItem.datasetIndex].label || '';

              if (label) {
                label += ': ';
              }
              const dataNum = Math.round(tooltipItem.yLabel * 100) / 100;
              label += format.transform(dataNum);
              return label;
            }
          }
        },
        scales: {
          xAxes: [{
            barPercentage: 0.25,
            beginAtZero: true,
            ticks: {
              autoSkip: false,
              fontSize: 10,
            },
            stacked: true,
            gridLines: {
              display: false,
              drawBorder: false,
            },
          }],
          yAxes: [{
            stacked: true,
            barPercentage: 0.35,
            gridLines: {
              color: 'rgb(247, 250, 252)',
              borderDash: [5, 0],
              zeroLineColor: 'rgb(247, 250, 252)',
            },
            ticks: {
              fontSize: 9,
              beginAtZero: true,
              callback: function (label, index, labels) {
                return label / 1000 + 'k';
              }
            }
          }]
        },
      }
    };

    var ctx = $('#registrationsByAge');
    this.registrationByAgeChart = new Chart(ctx, configuration);
  }

  //registration vs appointment chart
  loadRegVsAppointmentChart() {
    if (this.regVsAppointmentChart) {
      this.regVsAppointmentChart.destroy();
    }

    const lineChartData = this.appointmentDailyData.sort((a, b) => (a.appointment_date > b.appointment_date) ? 1 : -1)
    const labels = _.map(this.appointmentDailyData, (data) => {
      return moment(data.appointment_date).format('DD MMM');
    });

    const data1 = _.map(this.regDailyData, 'total');
    const data2 = _.map(this.appointmentDailyData, 'total_appointments');

    const format = this.numberFormatPipe;
    var configuration = {
      type: 'line',
      data: {
        labels: labels,
        datasets: [{
          type: 'line',
          label: 'Registrations',
          // backgroundColor: 'rgb(255, 152 , 0, 0.5)',
          backgroundColor: 'rgb(90, 141, 238, 0.1)',
          borderColor: 'rgb(90, 141, 238)',
          borderWidth: 2,
          pointBackgroundColor: "rgb(79, 95, 125)",
          pointBorderWidth: 1,
          pointRadius: 3,
          fill: true,
          
          
          data: data1,
        }, {
          type: 'line',
          label: 'Appointments',
          backgroundColor: 'rgb(20, 232, 251, 0.1)',
          borderColor: 'rgb(20, 232, 251)',
          borderWidth: 2,
          pointBackgroundColor: 'rgb(1, 161, 179)',
          pointBorderWidth: 1,
          pointRadius: 3,
          
          fill:true,
          data: data2,
        }]
      },
      options: {
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            usePointStyle: false,
            boxWidth: 20,
            padding: 15,
            fontSize: 9,
          }
        },
        tooltips: {
          mode: 'index',
          intersect: false,
          callbacks: {
            label: function (tooltipItem, data) {
              var label = data.datasets[tooltipItem.datasetIndex].label || '';

              if (label) {
                label += ': ';
              }

              const dataNum = Math.round(tooltipItem.yLabel * 100) / 100;
              label += format.transform(dataNum);
              return label;
            }
          }
        },
        responsive: true,
        scales: {
          xAxes: [{
            beginAtZero: false,
            ticks: {
              autoSkip: false,
              fontSize: 11,
            },
            // stacked: true,
            gridLines: {
              display: false,
              drawBorder: false,
            },
          }],
          yAxes: [{
            // stacked: true,
            barPercentage: 0.3,
            gridLines: {
              color: 'rgb(247, 250, 252)',
              borderDash: [5, 2],
              zeroLineColor: 'rgb(247, 250, 252)',
            },
            ticks: {
              fontSize: 9,
              beginAtZero: true,
              callback: function (label, index, labels) {
                return label / 1000 + 'k';
              }
            }
          }]
        }
      }
    };
    var ctx = $('#registration-appointments');
    this.regVsAppointmentChart = new Chart(ctx, configuration);
    this.regVsAppointmentChart.update();
  }

}
